import { Heart } from 'lucide-react';
import { MemoryCard } from '../components/MemoryCard';
import { memories } from '../data/memories';

export const MemoriesPage = () => {
  return (
    <div className="min-h-screen pt-20 bg-[#0F0505]" data-testid="memories-page">
      {/* Hero Section */}
      <section className="py-20 md:py-32 relative overflow-hidden">
        {/* Background Decoration */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-[#722F37] rounded-full blur-3xl" />
          <div className="absolute bottom-1/4 left-1/4 w-96 h-96 bg-[#1B3A5F] rounded-full blur-3xl" />
        </div>

        <div className="max-w-4xl mx-auto px-4 md:px-8 text-center relative z-10">
          {/* Decorative Element */}
          <div className="flex items-center justify-center gap-4 mb-8">
            <div className="w-16 h-px bg-[#D4AF37]" />
            <Heart className="w-6 h-6 text-[#D4AF37]" fill="#D4AF37" />
            <div className="w-16 h-px bg-[#D4AF37]" />
          </div>

          <p className="text-[#D4AF37] text-sm tracking-[0.2em] uppercase mb-4">Our Collection</p>
          <h1 className="font-['Playfair_Display'] text-4xl md:text-5xl lg:text-6xl text-[#F5F5F0] mb-8">
            Memories
          </h1>
          <p className="text-[#A18E90] text-lg md:text-xl leading-relaxed max-w-2xl mx-auto">
            Every photograph tells a story. Every moment captured is a piece of our journey together.
          </p>
        </div>
      </section>

      {/* Memories Grid */}
      <section className="py-16 md:py-24 bg-[#1A0F0F]/30" data-testid="memories-grid">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {memories.map((memory, index) => (
              <div 
                key={memory.id} 
                className="animate-fade-in-up opacity-0"
                style={{ animationDelay: `${index * 0.1}s`, animationFillMode: 'forwards' }}
              >
                <MemoryCard memory={memory} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <section className="py-20 md:py-32 bg-[#0F0505]">
        <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
          <Heart className="w-8 h-8 text-[#D4AF37] mx-auto mb-8" fill="#D4AF37" />
          <blockquote className="font-['Cormorant_Garamond'] text-2xl md:text-3xl text-[#A18E90] italic leading-relaxed mb-8">
            "The best thing to hold onto in life is each other."
          </blockquote>
          <div className="w-16 h-px bg-[#D4AF37] mx-auto mb-6" />
          <p className="text-[#D4AF37] text-sm tracking-widest uppercase">
            - Audrey Hepburn
          </p>
        </div>
      </section>
    </div>
  );
};
